/* melee-v2-story.js — migrated out of sections/melee-v2-story.liquid's {% javascript %} block
   to avoid the local theme-dev compiled_assets/scripts.js truncation bug. */
(function () {
    function initStory(root) {
      if (!root || root.dataset.mv2StoryReady) return;
      root.dataset.mv2StoryReady = '1';

      var track = root.querySelector('[data-mv2-story-track]');
      if (!track) return;

      function clamp(v, a, b) {
        a = a === undefined ? 0 : a;
        b = b === undefined ? 1 : b;
        return Math.max(a, Math.min(b, v));
      }
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      var sp = 0,
        targetP = 0,
        rafId = null,
        overflow = 0;

      function layout() {
        overflow = Math.max(0, track.scrollWidth - window.innerWidth);
        root.style.height = window.innerHeight + overflow + 'px';
        computeTarget();
        apply();
      }

      function computeTarget() {
        var rect = root.getBoundingClientRect();
        var scrollable = rect.height - window.innerHeight;
        targetP = scrollable > 0 ? clamp(-rect.top / scrollable) : 0;
      }

      function apply() {
        track.style.transform = 'translate3d(' + (-sp * overflow).toFixed(2) + 'px, 0, 0)';
      }

      function tick() {
        var diff = targetP - sp;
        if (Math.abs(diff) < 0.0004) {
          sp = targetP;
          apply();
          rafId = null;
          return;
        }
        sp += diff * 0.12;
        apply();
        rafId = requestAnimationFrame(tick);
      }
      function requestTick() {
        if (rafId == null) rafId = requestAnimationFrame(tick);
      }

      function onScroll() {
        computeTarget();
        if (reduce) {
          sp = targetP;
          apply();
          return;
        }
        requestTick();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', layout, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);

      layout();
    }

    function initAll() {
      document.querySelectorAll('[data-mv2-story]').forEach(initStory);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.matches('[data-mv2-story]') ? e.target : e.target.querySelector('[data-mv2-story]');
      if (root) initStory(root);
    });
  })();
